<template>
	<div class="teacherManager">

		<div class="breadcrumb" style="font-size: 14px; ">教师管理</div>

		<div class="selectSchool">
			<el-select class="selectInput" v-model="region" filterable clearable placeholder="请输入高校名称"
				:loading="loading" @change="getTeachers">
				<el-option v-for="item in option" :key="item.rootUnid" :label="item.name" :value="item.rootUnid">
				</el-option>
			</el-select>
		</div>

		<div class="warning" style="font-size: 14px; margin-left: 15px;">提示：教师添加成功后，其账号密码默认为123456</div>

		<div class="com-list">
			<el-table class="teacherData" :data="teacherData" style="width: 100%">
				<el-table-column type="index" prop="index" label="序号" width="80">
				</el-table-column>
				<el-table-column prop="stuId" label="教职工号" width="200">
				</el-table-column>
				<el-table-column prop="name" label="姓名" width="150">
				</el-table-column>
				<el-table-column prop="campusZone" label="校区" width="200">
				</el-table-column>
				<el-table-column prop="phone" label="手机号" width="200">
				</el-table-column>
				<el-table-column prop="gender" label="性别">
				</el-table-column>
			</el-table>
		</div>
		<div class="warningsuccess" v-show="isimportsuccess" style="font-size: 14px; margin-left: 15px; color: red;">
			提示：
			<br /> 1,新添加成功老师{{numSetteacher}}个
			<br /> 2,{{alreadyteacher}}已经是老师
		</div>
		<br />
		<br />
		<div class="wrongInfo" style="font-size: 14px; margin-left: 15px;" v-show="wrongData.length > 0">
			{{wrongData.length}}个用户已存在，用户在数据库中的信息如下，以手机号为唯一标识，教工号、姓名或校区冲突认为是冲突
		</div>

		<el-table class="wrongData" v-show="wrongData.length > 0" :data="wrongData" style="width: 100%;">
			<el-table-column type="index" prop="index" label="序号" width="80">
			</el-table-column>
			<el-table-column prop="phone" label="手机号码" width="150">
			</el-table-column>
			<el-table-column prop="name" label="姓名" width="120">
			</el-table-column>
			<el-table-column prop="campusZone" label="校区" width="200">
			</el-table-column>
			<el-table-column prop="stuId" label="学号/教职工号" width="200">
			</el-table-column>
			<el-table-column prop="gender" label="性别">
			</el-table-column>
		</el-table>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				region: '',
				option: [],
				teacherData: [],
				wrongData: [],
				ishasteacherData: false,
				importteacherurl: '/adminapi/v1/campus/teacher/importTeacher?rootUnid=',
				alreadyteacher: '',
				numSetteacher: '',
				isimportsuccess: false
			}
		},
		mounted() {
			this.getallschool();
		},
		computed: {
			importteacherurltrueth() {
				return this.$util.domain + this.importteacherurl + this.region;
			}
		},
		methods: {
			//请求所有校区
			getallschool() {
				this.$http({
					method: 'get',
					url: this.$util.domain + '/adminapi/v1/basicTools/allSchools'
				}).then(response => {
					if (response.data.error == 10000) {
						this.option = response.data.data;
					} else {
						this.$util.errorMsg(response.data.message);
					}
				})
			},
			//根据校区获取老师
			getTeachers() {
				if (this.region) {
					this.ishasteacherData = true;//显示导入按钮
				}
				this.$http({
					method: 'get',
					url: this.$util.domain + '/adminapi/v1/campus/teacher/queryTeacher?rootUnid=' + this.region
				}).then(response => {
					if (response.data.error == 10000) {
						this.teacherData = response.data.data;
						for (let i = 0; i < this.teacherData.length; i++) {
							this.teacherData[i].gender = (this.teacherData[i].gender == 1) ? "男" : "女";
						}
					} else {
						this.$util.errorMsg(response.data.message);
					}
				})
			},
			//导入教师成功后
			handlerSuccess(response) {
				if (response.error == 10000) {
					this.$util.successMsg(response.message);
					this.wrongData = response.data.conflictInfo;//导入成功后显示冲突的列表
					for (let i = 0; i < this.wrongData.length; i++) {
						this.wrongData[i].gender = (this.wrongData[i].gender == 1) ? "男" : "女";
					}
					this.alreadyteacher = response.data.alreadyTeacher;//已经是老师的人名
					if (this.alreadyteacher == '') {
						this.alreadyteacher = '暂无人员'
					}
					this.numSetteacher = response.data.numSetTeacher;//设置成功老师的人数
					this.isimportsuccess = true;
				} else {
					this.$util.errorMsg(response.message);
				}
			},
			handlerError(response) {
				this.$util.errorMsg(response.message);
			}
		}
	}
</script>

<style>
	.teacherManager {
		overflow: hidden;
	}

	.wrongInfo {
		margin-bottom: 10px;
	}

	.teacherData {
		margin-bottom: 20px;
	}

	.wrongData {
		margin-bottom: 20px;
	}

	.teacherManager .uploadBtn {
		top: 130px;
	}
</style>


// WEBPACK FOOTER //
// teacherManage.vue?dec669ba